export type AppConfig = {
    CHAT_BASE: string;
    PROJECTS_API_BASE_GET: string;
    PROJECTS_API_BASE_POST: string;
};

const defaults: AppConfig = {
    CHAT_BASE: "",
    PROJECTS_API_BASE_GET: "/api/projects",
    PROJECTS_API_BASE_POST: "/api/projects"
};

export async function loadAppConfig(): Promise<AppConfig> {
    try {
        const res = await fetch("/config.json", { cache: "no-store" });
        if (!res.ok) throw new Error(String(res.status));
        const data = (await res.json()) as Partial<AppConfig>;
        return { ...defaults, ...data };
    } catch {
        return defaults;
    }
}
